import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

import { Limit } from "@/components/Limit";
import { DateRange } from "@/components/DateRange";
import { CATEGORIES } from "../../config";
import { useSourceBasedStore } from "../../store/sourceStore";
import { MediaTabContent } from "./SourceMediaTabContent";
import SourceKeyword from "./SourceKeyword";
import { SearchBar } from "./SourceSearchBar";

export function MediaTabs() {
  const activeTab = useSourceBasedStore((s) => s.activeTab);
  const setActiveTab = useSourceBasedStore((s) => s.setActiveTab);
  const search = useSourceBasedStore((s) => s.search);
  const setSearch = useSourceBasedStore((s) => s.setSearch);
  const limit = useSourceBasedStore((s) => s.limit);
  const setLimit = useSourceBasedStore((s) => s.setLimit);
  const dateRange = useSourceBasedStore((s) => s.dateRange);
  const setDateRange = useSourceBasedStore((s) => s.setDateRange);

  // // Call hooks individually for each subcategory
  // const printQuery0 = usePublicationsInfinite(
  //   CATEGORIES.print.subcategories[0],
  //   search,
  // );
  // const printQuery1 = usePublicationsInfinite(
  //   CATEGORIES.print.subcategories[1],
  //   search,
  // );
  // const printQuery2 = usePublicationsInfinite(
  //   CATEGORIES.print.subcategories[2],
  //   search,
  // );

  // const onlineQuery0 = usePublicationsInfinite(
  //   CATEGORIES.online.subcategories[0],
  //   search,
  // );
  // const onlineQuery1 = usePublicationsInfinite(
  //   CATEGORIES.online.subcategories[1],
  //   search,
  // );

  // const tvQuery0 = usePublicationsInfinite(
  //   CATEGORIES.tv.subcategories[0],
  //   search,
  // );

  // const radioQuery0 = usePublicationsInfinite(
  //   CATEGORIES.radio.subcategories[0],
  //   search,
  // );

  return (
    <div className="flex flex-col gap-4">
      <div className="flex w-full flex-row items-end gap-4">
        <div className="flex w-full flex-row items-end gap-4">
          <Limit
            limit={limit}
            setLimit={setLimit}
            customWidth="90px"
            useHeader={false}
          />
          <DateRange
            dateRange={dateRange}
            setDateRange={setDateRange}
            customWidth="175px"
            useHeader={false}
          />
        </div>
        <SearchBar
          value={search}
          onChange={setSearch}
          customWidth="620px"
          disabled={
            activeTab !== "print" &&
            activeTab !== "online" &&
            activeTab !== "tv" &&
            activeTab !== "radio"
          }
        />
      </div>
      <Tabs value={activeTab} onValueChange={(v) => setActiveTab(v as any)}>
        <div className="flex items-center justify-between">
          <TabsList>
            <TabsTrigger value="keyword">Keyword</TabsTrigger>
            <TabsTrigger value="print">Print</TabsTrigger>
            <TabsTrigger value="online">Online</TabsTrigger>
            <TabsTrigger value="tv">TV</TabsTrigger>
            <TabsTrigger value="radio">Radio</TabsTrigger>
          </TabsList>
        </div>

        <div className="flex-1 justify-between overflow-x-hidden">
          {/* Tabs content */}
          <TabsContent value="keyword">
            <SourceKeyword />
          </TabsContent>
          <TabsContent value="print">
            <MediaTabContent category={CATEGORIES.print} search={search} />
          </TabsContent>
          <TabsContent value="online">
            <MediaTabContent category={CATEGORIES.online} search={search} />
          </TabsContent>
          <TabsContent value="tv">
            <MediaTabContent category={CATEGORIES.tv} search={search} />
          </TabsContent>
          <TabsContent value="radio">
            <MediaTabContent category={CATEGORIES.radio} search={search} />
          </TabsContent>
        </div>
      </Tabs>
    </div>
  );
}
